import React, { useCallback, useMemo } from 'react';
import { Button, Flex, Heading, Text, useDisclosure } from '@televet/kibble-ui';
import PairingPinModal from './PairingPinModal';
import { useGenerateTerminalSetupPinMutation } from 'shared/types/graphql';
import useClinicUser from 'shared/hooks/useClinicUser';

const TerminalConfiguration = (): JSX.Element => {
  const { currentClinicId } = useClinicUser();
  const { isOpen: isPinModalOpen, onOpen: onPinModalOpen, onClose: onPinModalClose } = useDisclosure();

  const [generatePairingPin, { data: generatedPinData, loading: isGeneratingPin }] =
    useGenerateTerminalSetupPinMutation();

  const pin = useMemo(
    () => generatedPinData?.generateTerminalSetupPin?.pin,
    [generatedPinData?.generateTerminalSetupPin?.pin],
  );

  const handleGeneratePinClick = useCallback(() => {
    generatePairingPin({
      variables: { clinicId: currentClinicId || '' },
    });
    onPinModalOpen();
  }, [currentClinicId, generatePairingPin, onPinModalOpen]);

  return (
    <>
      <Flex pt={5} gap={5} direction="column">
        <Flex gap={5} direction="column" maxW={570}>
          <Heading size="md">Pairing</Heading>
          <Text
            size="sm"
            variant="subtle"
          >{`To pair your terminal with your clinic, you'll need to use a pairing code. You can use the same pairing code for multiple terminals.`}</Text>
          <Button width="fit-content" onClick={handleGeneratePinClick}>
            Show Pairing PIN
          </Button>
        </Flex>
      </Flex>
      <PairingPinModal pin={pin} isGeneratingPin={isGeneratingPin} isOpen={isPinModalOpen} onClose={onPinModalClose} />
    </>
  );
};

export default TerminalConfiguration;
